<template>
  <span v-html="formattedNumber" />
</template>

<script>
import tweeen from 'tweeen';

function cubicInOut(t) {
  return t < 0.5 ? 4.0 * t * t * t : 0.5 * (2.0 * t - 2.0) ** 3.0 + 1.0;
}

export default {
  name: 'NumberTransition',
  props: {
    splitByRanks: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 300
    },
    delay: {
      type: Number,
      default: 0
    },
    number: {
      type: Number,
      required: true
    },
    precision: {
      type: Number,
      default: 0
    },
    initialNumber: {
      type: Number,
      default(props) {
        return props.number;
      }
    },
    persistentLength: {
      type: Boolean,
      default: false
    },
    easing: {
      type: Function,
      default: cubicInOut
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayNumber: this.round(this.initialNumber)
    };
  },
  computed: {
    originalLength() {
      return String(this.round(this.number)).length;
    },
    formattedNumber() {
      let result = String(this.displayNumber);
      if (this.persistentLength) {
        result = result.padStart(this.originalLength, '0');
      }

      if (this.splitByRanks) {
        let newResult = '';
        for (let i = Math.ceil(result.length / 3) - 1; i >= 0; i -= 1) {
          const top = result.length - i * 3 - 3;
          if (newResult.length > 0) {
            newResult += '&thinsp;';
          }
          newResult += result.slice(Math.max(0, top), top + 3);
        }
        result = newResult;
      }

      return result.replace('.', ',');
    }
  },
  watch: {
    number(nextNumber) {
      this.transitionTo(nextNumber);
    }
  },
  created() {
    if (!this.disabled) {
      this.displayNumber = this.round(this.number);
    } else {
      setTimeout(() => {
        this.transitionTo(this.number);
      }, this.delay);
    }
  },
  methods: {
    round(number) {
      const dec = 10 ** this.precision;
      return Math.round(number * dec) / dec;
    },
    transitionTo(number) {
      if (number === this.displayNumber) {
        return;
      }

      if (this.stop) {
        this.stop();
      }

      this.stop = tweeen(
        this.displayNumber,
        number,
        (result) => {
          this.displayNumber = this.round(result);
        },
        {
          duration: this.duration,
          fps: 30,
          easing: this.easing
        }
      );
    }
  }
};
</script>

<style></style>

<i18n lang="json">{}</i18n>
